module.exports = " <div class=vc-picker-content> <picker-slot :divider=slot.divider :content=slot.content :text-align=slot.textAlign :width=slot.width v-for=\"slot in slots\" @slot-select=\"change($index, $arguments)\" :value=values[$index] :values=slot.values :visible-item-count=visibleItemCount></picker-slot> <div class=vc-picker-center-highlight></div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/picker/picker.vue
 ** module id = 473
 ** module chunks = 1
 **/